import React, { useMemo } from 'react';

import { FiPlus } from 'react-icons/fi';

import * as S from '../styles';

import { Card } from './Card';

import { Package } from '..';

type Props = {
  packages: Package[];
  loadPackages: () => Promise<void>;
  showContent: React.Dispatch<
    React.SetStateAction<'packages' | 'create-or-edit-package'>
  >;
  setIsCreateOrEdit: React.Dispatch<React.SetStateAction<'create' | 'edit'>>;
  setPackageToEditData: React.Dispatch<React.SetStateAction<Package>>;
};

const PackagesList: React.FC<Props> = ({
  packages,
  loadPackages,
  showContent,
  setIsCreateOrEdit,
  setPackageToEditData,
}: Props) => {
  const PackagesMemo = useMemo(
    () =>
      packages?.length ? (
        <S.CardContainer>
          {packages?.map((package_) => (
            <Card
              key={package_.id}
              packageData={package_}
              loadPackages={loadPackages}
              showContent={showContent}
              setIsCreateOrEdit={setIsCreateOrEdit}
              setPackageToEditData={setPackageToEditData}
            />
          ))}
        </S.CardContainer>
      ) : (
        <S.NoDataFound>
          <h1>Nenhum pacote encontrado!</h1>
        </S.NoDataFound>
      ),
    [packages],
  );

  return (
    <>
      <S.Header>
        <S.HeaderLabel>Pacotes</S.HeaderLabel>
      </S.Header>

      <S.CreatePackageButton
        type="button"
        onClick={() => {
          showContent('create-or-edit-package');
          setIsCreateOrEdit('create');
        }}
      >
        <FiPlus size={30} /> Novo pacote
      </S.CreatePackageButton>

      {PackagesMemo}
    </>
  );
};

export default PackagesList;
